// hong diem theo can ngay/nam - chi
export const HONG_DIEM = [[], [7], [9], [3], [8], [5], [5], [11], [10], [1], [9]]
// tu quan theo can - can + chi
export const TU_QUAN = [[], [7, 3], [8, 12], [2, 6], [5, 7], [4, 6], [7, 7], [9, 9], [10, 10], [10, 12], [9, 11]]
// van xuong quy nhan theo can ngay/nam - chi
// export const VAN_XUONG_QUY_NHAN = [[], [1, 7], [1, 7], [4, 10], [4, 10], [2, 5, 8, 11], [2, 5, 8, 11], [3, 12], [3, 12], [6, 9], [6, 9]]
export const VAN_XUONG_QUY_NHAN = [[], [6], [7], [9], [10], [9], [10], [12], [1], [3], [4]]
// thien at quy nhan theo can ngay/nam - chi
export const THIEN_AT_QUY_NHAN = [[], [2, 8], [1, 9], [12, 10], [12, 10], [2, 8], [1, 9], [3, 7], [3, 7], [4, 6], [4, 6]]
// thai cuc quy nhan theo can ngay/nam - chi
export const THAI_CUC_QUY_NHAN = [[], [1, 7], [1, 7], [4, 10], [4, 10], [2, 5, 8, 11], [2, 5, 8, 11], [3, 12], [3, 12], [6, 9], [6, 9]]
// quoc an quy nhan theo can ngay/nam - chi
export const QUOC_AN_QUY_NHAN = [[], [11], [12], [2], [3], [2], [3], [5], [6], [8], [9]]

// loc thien can theo can ngay - chi
export const LOC_THAN = [[], [3], [4], [6], [7], [6], [7], [9], [10], [12], [1]]
// kinh duong theo can - chi
export const KINH_DUONG = [[], [4], [3], [7], [6], [7], [6], [10], [9], [1], [12]]
// kim du theo can ngay - chi
export const KIM_DU = [[], [5], [6], [8], [9], [8], [9], [11], [12], [2], [3]]
// am duong sai lech theo can ngay - chi ngay
export const AM_DUONG_SAI_LECH = [[], [], [], [1, 7], [2, 8], [3, 9], [], [], [4, 10], [5, 11], [6, 12]]
// giap loc theo can ngay - chi
export const GIAP_LOC = [[], [2, 4], [3, 5], [5, 7], [6, 8], [5, 7], [6, 8], [8, 10], [9, 11], [11, 1], [12, 2]]
// am loc theo can ngay - chi
export const AM_LOC = [[], [12], [11], [9], [8], [9], [8], [6], [5], [3], [2]]
// thien loc (thien tai) theo can ngay - can
export const THIEN_LOC = [[], [5], [6], [7], [8], [9], [10], [1], [2], [3], [4]]

// trach ma (dich ma) theo chi nam/ngay - chi
export const TRACH_MA = [[], [3], [12], [9], [6], [3], [12], [9], [6], [3], [12], [9], [6]]
// hoa cai theo chi nam/ngay - chi
export const HOA_CAI = [[], [5], [2], [11], [8], [5], [2], [11], [8], [5], [2], [11], [8]]
// tuong tinh theo chi nam/ngay - chi
export const TUONG_TINH = [[], [1], [10], [7], [4], [1], [10], [7], [4], [1], [10], [7], [4]]
// dao hoa theo chi nam/ngay - chi
export const DAO_HOA = [[], [10], [7], [4], [1], [10], [7], [4], [1], [10], [7], [4], [1]]
// thien la theo chi nam/ngay - chi
export const THIEN_LA = [[], [], [], [], [], [], [], [], [], [], [], [12], [11]]
// dia vong theo chi nam/ngay - chi
export const DIA_VONG = [[], [], [], [], [], [6], [5], [], [], [], [], [], []]
// kiep sat theo chi nam/ngay - chi
export const KIEP_SAT = [[], [6], [3], [12], [9], [6], [3], [12], [9], [6], [3], [12], [9]]
// vong than theo chi nam/ngay - chi
export const VONG_THAN = [[], [12], [9], [6], [3], [12], [9], [6], [3], [12], [9], [6], [3]]

// thien duc quy nhan chi thang - can/chi
export const THIEN_DUC_QUY_NHAN_CAN = [[], [], [7], [4], [], [9], [8], [], [1], [10], [], [3], [2]]
export const THIEN_DUC_QUY_NHAN_CHI = [[], [6], [], [], [9], [], [], [12], [], [], [3], [], []]
// nguyet duc quy nhan theo chi thang - can
export const NGUYET_DUC_QUY_NHAN = [[], [9], [7], [3], [1], [9], [7], [3], [1], [9], [7], [3], [1]]
// duc quy nhan theo chi thang - can
export const DUC_QUY_NHAN = [[], [9, 10, 5, 6], [7, 8], [3, 4], [1, 2], [9, 10, 5, 6], [7, 8], [3, 4], [1, 2], [9, 10, 5, 6], [7, 8], [3, 4], [1, 2]]
// tu quy nhan theo chi thang - can
export const TU_QUY_NHAN = [[], [3, 8, 1, 6], [7, 2], [5, 10], [4, 9], [3, 8, 1, 6], [7, 2], [5, 10], [4, 9], [3, 8, 1, 6], [7, 2], [5, 10], [4, 9]]
// thien y theo chi thang  - chi
export const THIEN_Y = [[], [12], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11]]
// am chu duong thu theo chi thang  - chi
export const AM_CHU_DUONG_THU = [[], [3], [2], [1], [12], [11], [10], [11], [12], [1], [2], [3], [4]]

// co than theo chi nam - chi
export const CO_THAN = [[], [3], [3], [6], [6], [6], [9], [9], [9], [12], [12], [12], [3]]
// qua tu theo chi nam - chi
export const QUA_TU = [[], [11], [11], [2], [2], [2], [5], [5], [5], [8], [8], [8], [11]]
// tai sat theo chi nam - chi
export const TAI_SAT = [[], [7], [4], [1], [10], [7], [4], [1], [10], [7], [4], [1], [10]]
// hong loan theo chi nam - chi
export const HONG_LOAN = [[], [4], [3], [2], [1], [12], [11], [10], [9], [8], [7], [6], [5]]
// thien hy theo chi nam - chi
export const THIEN_HY = [[], [10], [9], [8], [7], [6], [5], [4], [3], [2], [1], [12], [11]]
// tang mon theo chi nam - chi
export const TANG_MON = [[], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [1], [2]]
// dieu khach theo chi nam - chi
export const DIEU_KHACH = [[], [11], [12], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10]]
// huyet nhan theo chi nam - chi
export const HUYET_NHAN = [[], [11], [10], [9], [8], [7], [6], [5], [4], [3], [2], [1], [12]]
// quan phu theo chi nam - chi
export const QUAN_PHU = [[], [5], [6], [7], [8], [9], [10], [11], [12], [1], [2], [3], [4]]
// cach goc theo chi nam - chi
export const CACH_GOC = [[], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [1], [2]]

// tam ky quy nhan tu tru co 1 trong 3,
// theo thu tu can nam/thang/ngay hoac thang/ngay/gio hoac ngay/thang/nam
export const TAM_KY_QUY_NHAN = [[1, 5, 7], [2, 3, 4], [9, 10, 8]]
// phuc tinh quy nhan theo can ngay/nam - chi
export const PHUC_TINH_QUY_NHAN = [[], [1, 3], [2, 4], [1, 3], [12], [9], [8], [7], [6], [5], [2, 4]]
// khoi canh theo can - chi
export const KHOI_CANH_QUY_NHAN = [[], [], [], [], [], [11], [], [5, 11], [], [5], []]
// hoc duong theo ngu hanh nap am nam/ngay [kim, moc, thuy, hoa, tho] - chi
export const HOC_DUONG = [[], [6], [12], [9], [3], [9]]
// kim than theo can - chi cua tru ngay/gio
export const KIM_THAN = [[], [], [2], [], [], [], [6], [], [], [], [10]]
export const KIM_THAN_THANG_CHI = [6, 7]
export const KIM_THAN_CAN = [3, 4]
export const KIM_THAN_NGAY_CAN = [1, 6]
// cung loc theo ngay/gio can - chi
export const CUNG_LOC_NGAY = [[], [[10, 2], [10, 12]], [], [], [], [], [[5, 5]], [[4, 6], [6, 8]], [], [], [], [], []]
export const CUNG_LOC_GIO = [[], [[10, 12], [10, 2]], [], [], [], [], [5, 7], [[4, 8]], [6, 6], [], [], [], []]
// thien xa theo chi thang - can-chi
export const THIEN_XA = [[], [1, 1], [1, 1], [5, 3], [5, 3], [5, 3], [1, 7], [1, 7], [1, 7], [5, 9], [5, 9], [5, 9], [1, 1]]
// cau, giao
// nguyen than theo chi nam - chi
export const NGUYEN_THAN_THUAN = [[], [8], [9], [10], [11], [12], [1], [2], [3], [4], [5], [6], [7]]
export const NGUYEN_THAN_NGHICH = [[], [6], [7], [8], [9], [10], [11], [12], [1], [2], [3], [4], [5]]
// thap ac dai bai theo can ngay - chi ngay
export const THAP_AC_DAI_BAI = [[], [5], [6], [9], [12], [11], [2], [5], [6], [9], [12]]
// tu phe theo can ngay - chi ngay
export const TU_PHE = [[], [[3, 7], [4, 6]], [[3, 7], [4, 6]], [[7, 9], [8, 10]], [[7, 9], [8, 10]], [[7, 9], [8, 10]], [[9, 1], [10, 12]], [[9, 1], [10, 12]], [[9, 1], [10, 12]], [[1, 3], [2, 4]], [[1, 3], [2, 4]], [[1, 3], [2, 4]], [[3, 7], [4, 6]]]
// co loan theo can ngay/gio - chi ngay/gio
export const CO_LOAN = [[], [], [6], [7], [6], [7, 9], [], [], [12], [1, 3], []]

export const CAT_TINH = {
  TU_QUAN: {
    name: 'Từ Quán',
    desc: ''
  },
  VAN_XUONG_QUY_NHAN: {
    name: 'Văn Xương',
    des: ''
  },
  THIEN_AT_QUY_NHAN: {
    name: 'Thiên Ất Quý Nhân',
    des: 'Thiên Ất quý nhân là thần tốt nhất trong mệnh chủ về thông minh, trí tuệ, là thần gặp hung hóa cát..... Nếu hợp hóa thành hỷ, dụng thần là rất tốt, rất kỵ gặp hình, xung, khắc, hại, đất không vong, tử, mộ hay tuyệt.'
  },
  THAI_CUC_QUY_NHAN: {
    name: 'Thái Cực Quý Nhân',
    des: ''
  },
  QUOC_AN_QUY_NHAN: {
    name: 'Quốc Ấn Quý Nhân',
    des: ''
  },
  LOC_THAN: {
    name: 'Lộc Thần',
    des: ''
  },
  KIM_DU: {
    name: 'Kim Dư',
    des: ''
  },
  GIAP_LOC: {
    name: 'Giáp Lộc',
    des: ''
  },
  AM_LOC: {
    name: 'Ám Lộc',
    des: ''
  },
  THIEN_LOC: {
    name: 'Thiên Lộc (Thiên tài)',
    des: ''
  },
  TRACH_MA: {
    name: 'Dịch Mã',
    des: ''
  },
  HOA_CAI: {
    name: 'Hoa Cái',
    des: ''
  },
  TUONG_TINH: {
    name: 'Tướng Tinh',
    des: ''
  },
  THIEN_DUC_QUY_NHAN: {
    name: 'Thiên Đức Quý Nhân',
    des: 'Quý nhân Thiên Đức và Nguyệt Đức là cát tinh, tính tình nhân từ đôn hậu, cuộc đời phúc nhiều, ít gặp nguy hiểm, gặp hung hóa cát, hóa hiểm thành an.... như có thần linh hộ vệ. Nếu trong tứ trụ mà có cả Thiên, Nguyệt Đức thì người đó có năng lực gặp hung hóa cát rất mạnh, gặp phải hung thần cũng bớt xấu rất nhiều, nhưng gặp phải xung, khắc thì vô dụng.\n'
  },
  NGUYET_DUC_QUY_NHAN: {
    name: 'Nguyệt Đức Quý Nhân',
    des: 'Quý nhân Thiên Đức và Nguyệt Đức là cát tinh, tính tình nhân từ đôn hậu, cuộc đời phúc nhiều, ít gặp nguy hiểm, gặp hung hóa cát, hóa hiểm thành an.... như có thần linh hộ vệ. Nếu trong tứ trụ mà có cả Thiên, Nguyệt Đức thì người đó có năng lực gặp hung hóa cát rất mạnh, gặp phải hung thần cũng bớt xấu rất nhiều, nhưng gặp phải xung, khắc thì vô dụng.\n'
  },
  DUC_QUY_NHAN: {
    name: 'Đức Quý Nhân',
    des: ''
  },
  TU_QUY_NHAN: {
    name: 'Tú Quý Nhân',
    des: ''
  },
  THIEN_Y: {
    name: 'Thiên Y',
    des: ''
  },
  AM_CHU_DUONG_THU: {
    name: 'Âm Chú Dương Thụ',
    des: ''
  },
  HONG_LOAN: {
    name: 'Hồng Loan',
    des: ''
  },
  THIEN_HY: {
    name: 'Thiên Hỷ',
    des: ''
  },
  TAM_KY_QUY_NHAN: {
    name: 'Tam Kỳ Quý Nhân',
    des: ''
  },
  PHUC_TINH_QUY_NHAN: {
    name: 'Phúc Tinh Quý Nhân',
    des: ''
  },
  KHOI_CANH_QUY_NHAN: {
    name: 'Khôi Cương',
    des: ''
  },
  HOC_DUONG: {
    name: 'Học Đường',
    des: ''
  },
  KIM_THAN: {
    name: 'Kim Thần',
    des: ''
  },
  CUNG_LOC: {
    name: 'Củng Lộc',
    des: ''
  },
  THIEN_XA: {
    name: 'Thiên Xá',
    des: ''
  }
}

export const HUNG_TINH = {
  HONG_DIEM: {
    name: 'Hồng Diễm',
    des: ''
  },
  KINH_DUONG: {
    name: 'Kình Dương',
    des: ''
  },
  AM_DUONG_SAI_LECH: {
    name: 'Âm Dương Sai Lệch',
    des: ''
  },
  DAO_HOA: {
    name: 'Đào Hoa',
    des: ''
  },
  THIEN_LA: {
    name: 'Thiên La',
    des: ''
  },
  DIA_VONG: {
    name: 'Địa Võng',
    des: ''
  },
  KIEP_SAT: {
    name: 'Kiếp Sát',
    des: ''
  },
  VONG_THAN: {
    name: 'Vong Thần',
    des: ''
  },
  CO_THAN: {
    name: 'Cô Thần',
    des: ''
  },
  QUA_TU: {
    name: 'Quả Tú',
    des: ''
  },
  TAI_SAT: {
    name: 'Tai Sát',
    des: ''
  },
  TANG_MON: {
    name: 'Tang Môn',
    des: ''
  },
  DIEU_KHACH: {
    name: 'Điếu Khách',
    des: ''
  },
  HUYET_NHAN: {
    name: 'Huyết Nhẫn',
    des: ''
  },
  QUAN_PHU: {
    name: 'Quan Phù',
    des: ''
  },
  CACH_GOC: {
    name: 'Cách Góc',
    des: ''
  },
  CAU: {
    name: 'Cấu',
    des: ''
  },
  GIAO: {
    name: 'Giảo',
    des: ''
  },
  NGUYEN_THAN: {
    name: 'Nguyên Thần',
    des: ''
  },
  THAP_AC_DAI_BAI: {
    name: 'Thập Ác Đại Bại',
    des: ''
  },
  TU_PHE: {
    name: 'Tứ Phế',
    des: ''
  },
  KHONG_VONG: {
    name: 'Không Vong',
    des: ''
  },
  CO_LOAN: {
    name: 'Cô Loan',
    des: ''
  }
}
